// assets/js/two-cols.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function initTwoCols(section) {
  if (!section || section.__twoColsInit) return;
  section.__twoColsInit = true;

  const eyebrow = section.querySelector(".two-cols__eyebrow");
  const dot = eyebrow?.querySelector(".dot");
  const headline = section.querySelector(".two-cols__headline");
  const intro = section.querySelector(".two-cols__intro");
  const cta = section.querySelector(".two-cols__cta");

  const photoFig =
    section.querySelector(".two-cols__photo figure") ||
    section.querySelector(".two-cols__photo");
  const photoImg = section.querySelector(".two-cols__photo img");

  const featuresWrap = section.querySelector(".two-cols__features");
  const features = section.querySelectorAll(".two-cols__feature");

  gsap.set([eyebrow, headline, intro, cta], { opacity: 0, y: 20 });
  if (dot) gsap.set(dot, { scale: 0.65 });

  if (photoFig) gsap.set(photoFig, { opacity: 0, y: 16 });
  if (photoImg) gsap.set(photoImg, { scale: 1.06 });

  if (featuresWrap) gsap.set(featuresWrap, { opacity: 0, y: 14 });
  if (features?.length) gsap.set(features, { opacity: 0, y: 10 });

  const tlOpts = isEditor
    ? { defaults: { ease: "power3.out" } }
    : {
        defaults: { ease: "power3.out" },
        scrollTrigger: {
          trigger: section,
          start: "top 78%",
          once: true,
        },
      };

  const tl = gsap.timeline(tlOpts);

  if (photoFig) {
    tl.to(photoFig, { opacity: 1, y: 0, duration: 0.55 });
    if (photoImg) {
      tl.to(photoImg, { scale: 1, duration: 0.9, ease: "power2.out" }, "<");
    }
  }

  if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 }, "-=0.25");
  if (dot) tl.to(dot, { scale: 1, duration: 0.35, ease: "back.out(2)" }, "<");

  if (headline) {
    tl.fromTo(
      headline,
      { y: 28, opacity: 0, filter: "blur(3px)" },
      { y: 0, opacity: 1, filter: "blur(0px)", duration: 0.7 },
    );
  }

  if (intro) tl.to(intro, { opacity: 1, y: 0, duration: 0.55 }, "-=0.35");
  if (cta) tl.to(cta, { opacity: 1, y: 0, duration: 0.55 }, "-=0.35");

  if (featuresWrap) {
    tl.to(featuresWrap, { opacity: 1, y: 0, duration: 0.45 }, "-=0.25");
  }

  if (features?.length) {
    tl.to(
      features,
      { opacity: 1, y: 0, duration: 0.45, stagger: 0.06 },
      "-=0.25",
    );
  }

  if (!isEditor && photoFig) {
    gsap.to(photoFig, {
      y: -10,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.4,
      },
    });
  }

  if (!isEditor && featuresWrap) {
    gsap.to(featuresWrap, {
      y: -6,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.35,
      },
    });
  }
}

const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".two-cols").forEach(initTwoCols);
    return;
  }

  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () => root.querySelectorAll(".two-cols").forEach(initTwoCols);

  run();

  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) {
  window.wp.domReady(mount);
} else {
  document.addEventListener("DOMContentLoaded", mount);
}
